<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong>เพิ่มแพทย์ <i class="far fa-plus"></i></strong>
      </div>
      <div class="card-body">
        <div v-if="submit.active==false">
          <div class="col-lg-12 col-sm-12 form-group row" v-if="doctor.languages.data.length != 1">
            <div v-for="language in doctor.languages.data" :key="language.short_name" class="mx-1 text-center">
              <b-button v-if="language.short_name" block variant="outline-info" @click="setLanguage(language.short_name)"
                :class="{active: language.short_name === data.lang }">
                {{ language.name }}
                <span v-bind:class="'flag-icon flag-icon-us'" v-if="covertoLowerCase(language.short_name)=='en'"></span>
                <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(language.short_name)" v-if="covertoLowerCase(language.short_name)!='en'"></span>
              </b-button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">ชื่อแพทย์<span v-if="data.doctor.lang!=''"> {{data.doctor.lang}}</span>&nbsp;<i class="far fa-bookmark"></i>
                  : </label>
                <input class="form-control" v-model="data.doctor[data.lang].name" type="text" placeholder="กรุณากรอกชื่อแพทย์">
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">ข้อมูลเฉพาะทาง&nbsp;<i class="far fa-cube"></i> : </label>
                <input class="form-control" v-model="data.doctor[data.lang].specialty_name" type="text" placeholder="กรุณากรอกข้อมูลเฉพาะทาง">
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">ชื่อคลินิก&nbsp;<i class="fal fa-hospital"></i> : </label>
                <input class="form-control" v-model="data.doctor[data.lang].clinic_name" type="text" placeholder="กรุณากรอกชื่อคลินิก">
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">Booking URL&nbsp;<i class="fal fa-container-storage"></i> : </label>
                <input class="form-control" v-model="data.doctor[data.lang].booking_url" type="text" placeholder="กรุณากรอก Booking URL">
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">วันที่สร้าง: </label>
                <datepicker :bootstrap-styling="true" v-model="data.doctor[data.lang].created_at" placeholder="กรุณาคลิกเลือกวันที่สร้าง"></datepicker>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group row">
              <div class="offset-lg-3 col-lg-6 text-center">
                <label for="ccnumber">รูปตัวอย่าง <i class="far fa-image"></i></label>
                <img v-bind:src="data.image" @error="imageLoadError" class="d-block w-full">
              </div>
            </div>
            <div class="form-group row">
              <div class="offset-lg-2 col-lg-4">
                <button type="button" class="btn btn-outline-primary btn-block w-full" @click="openModal('upload')"><i
                    class="far fa-upload"></i> อัพโหลดรูปจากเครื่อง</button>
              </div>
              <div class="col-lg-4">
                <button type="button" class="btn btn-outline-info btn-block w-full" @click="openModal('link')"><i class="far fa-link"></i>
                  อัพโหลดรูปจากลิงค์</button>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="offset-sm-3 offset-lg-3 col-sm-3 col-lg-3">
              <button class="btn btn-primary w-full" type="submit" @click="submitDoctor"><i class="far fa-clipboard-check"></i>
                ยืนยัน</button>
            </div>
            <div class="col-sm-3 col-lg-3">
              <router-link :to="{ name: 'DoctorList'}"><button class="btn btn-secondary w-full" type="button"><i class="far fa-times-square"></i>
                  ยกเลิก</button></router-link>
            </div>
          </div>
        </div>
        <div v-if="submit.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="doctor.modal.title" ref="model" hide-footer v-model="doctor.modal.active" @ok="doctor.modal.active = false">
      <div v-if="doctor.modal.action=='link'">
        <div class="row">
          <div class="col-md-12">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">URL</span>
              </div>
              <input type="text" class="form-control" v-model="data.image">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
          </div>
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-secondary" block @click="cancleImageLink">ยกเลิกการเปลี่ยนแปลง</b-btn>
          </div>
        </div>
      </div>
      <div v-if="doctor.modal.action=='upload'">
        <div v-if="doctor.img.upload.active==false">
          <div class="custom-file" v-if="doctor.img.crop.active">
            <input type="file" name="image" accept="image/*" class="custom-file-input" @change="setImage" />
            <label class="custom-file-label" for="customFile">Choose file</label>
          </div>
          <div v-if="doctor.img.view.active">
            <div v-if="doctor.img.crop.active" style="width: 100%; height:100%; border: 1px solid gray; display: inline-block;">
              <vue-cropper ref='cropper' :src="doctor.img.view.src" :guides="true" :view-mode="2" drag-mode="crop"
                :initialAspectRatio="100/100" :aspectRatio="100/100" :auto-crop-area="0.5" :min-container-width="100"
                :min-container-height="100" :background="true" :rotatable="true" alt="zeedoc-img-doctor" :img-style="{ 'width': '100%', 'height': '100%' }">
              </vue-cropper>
            </div>
            <div>
              <div v-if="!doctor.img.crop.active">
                <label for="ccnumber">ภาพที่จะแสดงในแพทย์ <i class="far fa-image"></i></label>
                <img :src="doctor.img.crop.src" style="width: 100%; height: 52.85714%; border: 1px solid gray" alt="ตัวอย่างรูปที่จะนำเข้า" />
                <hr>
              </div>
            </div>
          </div>
          <div class="row" v-if="doctor.img.crop.active && doctor.img.view.src">
            <div class="offset-lg-2 col-lg-8">
              <br />
              <b-btn @click="cropImage" variant="primary" block>เลือกภาพนี้</b-btn>
            </div>
          </div>
          <div class="row" v-if="!doctor.img.crop.active && doctor.img.crop.src">
            <div class="col-lg-6">
              <b-btn variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
            </div>
            <div class="col-lg-6">
              <b-btn @click="cancleImage" variant="secondary" block>ยกเลิกภาพ</b-btn>
            </div>
          </div>
        </div>
        <div v-if="doctor.img.upload.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueCropper from 'vue-cropperjs'
  import uploadImage from '@/components/uploadImage'
  import Datepicker from 'vuejs-datepicker'
  import Helper from '@/shared/helper'
  export default {
    components: {
      Datepicker,
      VueCropper,
      uploadImage
    },
    mixins: [Helper],
    data() {
      return {
        load: 0,
        submit: {
          active: false,
          error: false
        },
        no_image: {
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        doctor: {
          id: parseInt(this.$route.params.id),
          languages: {
            count: 1,
            data: []
          },
          img: {
            upload: {
              active: false
            },
            view: {
              src: '',
              active: false
            },
            crop: {
              src: '',
              active: false
            }
          },
          modal: {
            title: '',
            action: '',
            active: false
          },
        },
        data: {
          page: 0,
          per_page: 0,
          lang: 'th',
          session: [],
          image: null,
          doctor: {
            th: {
              id: '',
              name: '',
              specialty_name: '',
              lang: '',
              clinic_name: '',
              booking_url: '',
              created_at: ''
            }
          }
        },
        authorization: 'Bearer ' + localStorage.getItem('z_token')
      }
    },
    methods: {
      covertoLowerCase(title) {
        if (title && title != '') {
          return title.toLowerCase()
        } else {
          return title
        }
      },
      openModal(action) {
        this.doctor.img.view.active = false
        this.doctor.modal.action = action
        this.doctor.img.crop.active = true
        if (action == 'upload') {
          this.doctor.img.view.src = null
          this.doctor.modal.title = 'อัพโหลดรูปจากเครื่อง'
          this.doctor.modal.active = true
        } else if (action == 'link') {
          this.doctor.modal.title = 'อัพโหลดรูปจากลิงค์'
          this.doctor.modal.active = true
        }
      },
      setLanguage(language) {
        this.data.lang = language
      },
      setImage(e) {
        const file = e.target.files[0]
        this.doctor.img.view.active = true
        if (!file.type.includes('image/')) {
          alert('Please select an image file')
          return
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.doctor.img.view.src = event.target.result
            this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
      },
      submitDoctor() {
        this.submit.active = true
        if (this.doctor.id != '' && this.doctor.id) {
          this.checkUpdateDoctor()
        } else {
          this.checkDoctor()
        }
      },
      imageLoadError(event) {
        this.data.image = ''
        event.target.src = this.no_image.src
      },
      checkDoctor() {
        this.data.session = []
        let item = null,
          isVal = false,
          emtpyCount = 0,
          data = [],
          active = true,
          textError = ''
        for (item in this.data.doctor) {
          if (this.data.doctor[item].name != '' && this.data.doctor[item].name && this.data.doctor[item].specialty_name !=
            '' && this.data.doctor[item].specialty_name && this.data.doctor[item].clinic_name != '' && this.data.doctor[
              item].clinic_name) {
            if (!isVal) {
              if (!(this.data.doctor[item].name.length > 5 || this.data.doctor[item].specialty_name.length > 5 || this.data
                  .doctor[item].clinic_name.length > 5)) {
                active = false
                textError = textError +
                  '- กรุณากรอกชื่อของแพทย์,ข้อมูลเฉพาะทาง,ชื่อคลินิก ที่มีความยามมากกว่า5ตัวอักษร (' + item + ')'
              }
            }
            isVal = true
          } else {
            emtpyCount = emtpyCount + 1
            if (emtpyCount == this.doctor.languages.count) {
              active = false
              textError = textError + '- กรุณาใส่ข้อมูลของแพทย์,ข้อมูลเฉพาะทาง,ชื่อคลินิก'
            }
          }
        }
        if (active === true) {
          isVal = false
          this.startLoad(this.doctor.languages.count)
          for (item in this.data.doctor) {
            if (this.data.doctor[item].name != '' && this.data.doctor[item].name && this.data.doctor[item].specialty_name !=
              '' && this.data.doctor[item].specialty_name && this.data.doctor[item].clinic_name != '' && this.data.doctor[
                item].clinic_name) {
              if (isVal) {
                this.data.session[item] = this.data.doctor[item]
              } else {
                if (this.data.doctor[item].name.length > 5 && this.data.doctor[item].specialty_name.length > 5 && this.data
                  .doctor[item].clinic_name.length > 5) {
                  this.createDoctor({
                    'name': this.data.doctor[item].name,
                    'specialty_name': this.data.doctor[item].specialty_name,
                    'image': this.data.image,
                    'locale': item,
                    'clinic_name': this.data.doctor[item].clinic_name,
                    'booking_url': this.data.doctor[item].booking_url,
                    'created_at': this.data.doctor[item].created_at
                  }, true)
                } else {
                  this.checkLoad()
                }
              }
              isVal = true
            } else {
              this.checkLoad()
            }
          }
        } else {
          this.submit.active = false
          alert(textError)
        }
      },
      async updateDoctor(data) {
        try {
          await this.$http.put(process.env.VUE_APP_API_URL + 'api/v1/doctor/' + this.doctor.id, data, {
            headers: {
              Authorization: this.authorization
            }
          })
        } catch (e) {
          if (this.submit.error == false) {
            this.submit.error = true
            alert('ไม่สามารถสร้างแพทย์ได้ กรุณากรอกชื่อของแพทย์!')
            this.$router.push({
              name: 'DoctorList'
            })
          }
        }
        this.checkLoad()
      },
      async checkUpdateDoctor() {
        let item = null
        let emtpyCount = 0
        this.startLoad(this.doctor.languages.count)
        for (item in this.data.doctor) {
          if (this.data.doctor[item].name != '' && this.data.doctor[item].name && this.data.doctor[item].clinic_name !=
            '' && this.data.doctor[item].clinic_name && this.data.doctor[item].specialty_name != '' && this.data.doctor[
              item].specialty_name) {
            if (this.data.doctor[item].name.length > 5 && this.data.doctor[item].clinic_name.length > 5 && this.data.doctor[
                item].specialty_name.length > 5) {
              await this.updateDoctor({
                'id': this.data.doctor[item].id,
                'name': this.data.doctor[item].name,
                'specialty_name': this.data.doctor[item].specialty_name,
                'image': this.data.image,
                'locale': item,
                'clinic_name': this.data.doctor[item].clinic_name,
                'booking_url': this.data.doctor[item].booking_url,
                'created_at': this.data.doctor[item].created_at
              })
            } else {
              this.checkLoad()
              alert("กรุณากรอกชื่อของแพทย์,ข้อมูลเฉพาะทาง,ชื่อคลินิก ที่มีความยามมากกว่า5ตัวอักษร (" + item + ")")
            }
          } else {
            this.checkLoad()
            emtpyCount = emtpyCount + 1
            if (emtpyCount == this.doctor.languages.count) {
              this.submit.active = false
              alert('กรุณาใส่ข้อมูลของแพทย์,ข้อมูลเฉพาะทาง,ชื่อคลินิก')
            }
          }
        }
        if (this.load == 0) {
          alert('แพทย์อัพเดทเรียบร้อย')
          this.$router.push({
            name: 'DoctorList'
          })
        }
      },
      createDoctor(data, isfunc) {
        this.$http.post(process.env.VUE_APP_API_URL + 'api/v1/doctor', data, {
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          let item = null
          this.checkLoad()
          if (isfunc == true) {
            for (item in this.data.session) {
              this.createDoctor({
                'title': this.data.session[item].title,
                'specialty_name': this.data.session[item].specialty_name,
                'image': this.data.session[item].image,
                'id': response.body.json.doctor.id,
                'locale': item,
                'clinic_name': this.data.session[item].clinic_name,
                'booking_url': this.data.session[item].booking_url,
                'created_at': this.data.session[item].created_at
              }, false);
            }
          }
          if (this.load == 0) {
            alert('แพทย์สร้างเรียบร้อย');
            this.$router.push({
              name: 'DoctorList'
            })
          }
        }).catch(function (error) {
          if (this.submit.error == false) {
            this.submit.error = true
            alert('ไม่สามารถสร้างแพทย์ได้ กรุณากรอกชื่อของแพทย์!');
            this.$router.push({
              name: 'DoctorList'
            })
          }
        })
      },
      cropImage() {
        this.doctor.img.crop.active = false
        this.doctor.img.crop.src = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      },
      cancleImage() {
        this.doctor.img.view.src = null
        this.doctor.img.view.active = false
        this.doctor.img.crop.active = true
        this.doctor.img.crop.src = null
      },
      cancleImageLink() {
        this.doctor.img.view.active = false
        this.doctor.img.crop.active = true
        this.doctor.img.crop.src = null
        this.data.image = ''
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      async submitImage() {
        if (this.doctor.img.crop.src != '' && this.doctor.img.crop.src) {
          this.doctor.img.upload.active = true
          try {
            this.data.image = await this.uploadImageDataUrl(this.doctor.img.crop.src, 'doctor.jpg')
            this.doctor.img.upload.active = false
            this.cancleImageLink
            this.$refs.model.hide()
          } catch (error) {
            this.doctor.img.upload.active = false
            alert('คุณใส่ชนิดหรือรูปแบบของรูปภาพไม่ถูกต้อง!')
            this.cancleImageLink
            this.$refs.model.hide()
          }
        } else {
          this.doctor.img.upload.active = false
          this.$refs.model.hide()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      getDoctorByID(id, lang) {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/doctor/' + id, {
          params: {
            lang: lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          if (response.body.json) {
            this.data.doctor[response.body.json.locale].id = response.body.json.id
            this.data.doctor[response.body.json.locale].name = response.body.json.name
            this.data.doctor[response.body.json.locale].specialty_name = response.body.json.specialty_name
            this.data.doctor[response.body.json.locale].clinic_name = response.body.json.clinic_name
            this.data.doctor[response.body.json.locale].booking_url = response.body.json.booking_url
            this.data.doctor[response.body.json.locale].created_at = response.body.json.created_at
            if (response.body.json.image && response.body.json.image != '') {
              this.data.image = response.body.json.image
            } else {
              this.data.image = null
            }
          }
        }, response => {
          this.checkLoad()
        })
      },
      getLanguages() {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/languages', {
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          const numLanguage = response.body.json.length
          let item = null
          if (numLanguage >= 1) {
            this.doctor.languages.count = response.body.json.length
            this.doctor.languages.data = response.body.json
            this.startLoad(this.doctor.languages.count + 1)
            for (item in this.doctor.languages.data) {
              this.data.doctor[this.doctor.languages.data[item].short_name] = {
                name: '',
                image: '',
                specialty_name: '',
                lang: '',
                clinic_name: '',
                booking_url: '',
                created_at: '',
              }
              if (Number.isInteger(this.doctor.id)) {
                this.getDoctorByID(this.doctor.id, this.doctor.languages.data[item].short_name)
              }
            }
            this.setLanguage(this.doctor.languages.data[0].short_name)
          }
        }, response => {
          this.failLoad()
        })
      }
    },
    mounted() {
      this.getLanguages()
    }
  }

</script>
